import { useCallback } from 'react';
import {
  useQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  OperationVariables,
  QueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/UserProposal.graphql';
import { Query } from '../../__generated__/globalTypes';

export const useUserProposalQuery = (options?: QueryHookOptions<Query>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useUserProposalLazyQuery = (
  options?: LazyQueryHookOptions<Query>
): QueryResult<Query> & { getUserProposalQuery: LazyQueryExecFunction<Query, OperationVariables> } => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  // TODO: should be getUserProposal
  const [getUserProposalQuery, result] = useLazyQuery<Query>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getUserProposalQuery, ...result };
};

export const useUserProposalPromiseQuery = () => {
  const client = useApolloClient();

  const getUserProposal = useCallback(
    (options?: Omit<QueryOptions<Record<string, unknown>, Query>, 'query'>) =>
      client.query<Query>({ ...options, query: QUERY }),
    [client]
  );

  return { getUserProposal };
};
